/* eslint-disable */
export default {
  dialPlaceholder: 'Anna nimi tai numero',
} as const;

// @key: @#@"dialPlaceholder"@#@ @source: @#@"Enter name or number"@#@
